import { TagType } from './signal-group'

export type RawMITRETechnique = {
  ID: string
  name: string
}

export interface Signal {
  strength: number
  description: string[]
  origin: string
  originId: string
  tags?: TagType[]
  additionalMessage?: string
  emulationEventID?: string
}

export enum SignalStrength {
  Whitelisted = -1.0,
  NoImpact = 0.0,
  VeryLowImpact = 0.1,
  LowImpact = 0.25,
  ConsiderableImpact = 0.5,
  SevereImpact = 0.75,
  CriticalImpact = 1.0,
}

export const signalStrengthList = Object.values(SignalStrength)
  .filter((v) => typeof v === 'number')
  .sort((a, b) => (a as number) - (b as number)) as number[]

export enum SignalVerdict {
  Malicious = 'malicious',
  Likely_malicious = 'likely_malicious',
  Suspicious = 'suspicious',
  Informational = 'informational', // BC, replaced with no_threat
  No_threat = 'no_threat',
  Benign = 'benign',
  Unknown = 'unknown',
  System_error = 'system_error',
}

type SignalVerdictType = typeof SignalVerdict
export type UniqueSignalVerdict = Omit<SignalVerdictType, 'Informational' | 'System_error'>

export type VerdictData = {
  name: SignalVerdict
  original?: SignalVerdict
  confidence?: number
  threatLevel?: number
  interestingScore?: number
  comment?: string
}

export type VerdictColorVariant = SignalVerdict | 'error' | 'neutral'
